<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')"/>
    <MenuHealthCompact v-else/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Help</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">User Manual</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Chapter #1</a></li>
                    </ul>

                    <h3>Chapter #1</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callUserManual" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to User Manual Introduction</span>
                                </a>
                            </li>
                        </ul>
                    </div>


                    <div class="surface-section px-4 py-8 md:px-6 lg:px-8">
                        <div class="text-600 text-sm mb-3">
                            <span>Published </span>
<!--                            <span class="font-bold">April 6, 2021</span>-->
                            <span> by </span>
                            <span class="font-bold">Rashmi Gowda</span>
                        </div>
                        <div class="border-blue-600 font-medium text-2xl p-3 mb-3 text-900" style="border-left: 8px solid">
                            Chapter #1
                        </div>

                        <div class="line-height-3 text-xl text-700 mb-5">Metus aliquam eleifend mi in nulla posuere. In vitae turpis massa sed elementum tempus egestas sed. Dui ut ornare lectus sit. Massa ultricies mi quis hendrerit.</div>
                        <div class="mb-5">
                            <Tag value="New" class="mr-2"></Tag>
                            <Tag value="Technology" severity="success" class="mr-2"></Tag>
                            <Tag value="Education" severity="warning"></Tag>
                        </div>
                        <div class="line-height-3 text-lg text-700 mb-4">
                            Nisi est sit amet facilisis. Ac odio tempor orci dapibus ultrices in iaculis nunc sed. Pellentesque pulvinar pellentesque habitant morbi tristique senectus. Nullam vehicula ipsum a arcu cursus vitae congue.
                            Leo urna molestie at elementum eu facilisis. Fusce id velit ut tortor. Purus non enim praesent elementum facilisis leo vel fringilla est. Semper risus in hendrerit gravida rutrum quisque non tellus orci.
                            Neque convallis a cras semper. Vitae elementum curabitur vitae nunc sed. Ornare massa eget egestas purus viverra accumsan in. Leo integer malesuada nunc vel risus commodo viverra maecenas accumsan.
                            Sit amet risus nullam eget. Egestas maecenas pharetra convallis posuere morbi leo urna molestie at.
                        </div>
                        <blockquote class="line-height-3 text-xl text-600 mb-4 py-0 mx-0 px-4">
                            “In short, GPU.js is a JavaScript acceleration library that can be used for general-purpose computations on GPUs using JavaScript. It supports browsers, Node.js and TypeScript.”
                        </blockquote>
                        <div class="line-height-3 text-lg text-700 mb-4">
                            Convallis tellus id interdum velit laoreet id donec ultrices. Lacus sed viverra tellus in hac habitasse platea dictumst. Ultricies tristique nulla aliquet enim. Nunc scelerisque viverra mauris in aliquam sem fringilla.
                            Laculis urna id volutpat lacus laoreet.
                        </div>
                        <ul class="mb-4 text-lg ml-6 p-0">
                            <li class="mb-3">Nunc sed velit dignissim sodales ut.</li>
                            <li class="mb-3">Lorem mollis aliquam ut porttitor. </li>
                            <li>Urna nec tincidunt praesent semper feugiat nibh sed.</li>
                        </ul>
                        <div class="text-center mb-4">
                            <img src="images/blocks/feature/feature-1.png" alt="Image" class="w-full border-round" />
                            <span class="block text-700 line-height-3 mt-2">Id porta nibh venenatis cras sed felis eget velit.</span>
                        </div>

                        <div class="text-2xl text-900 mb-4">Massa vitae tortor condimentum lacinia</div>
                        <div class="line-height-3 text-lg text-700 mb-4">
                            Lacus viverra vitae congue eu consequat ac felis donec et. A lacus vestibulum sed arcu non. Mauris vitae ultricies leo integer malesuada nunc vel. Dolor sit amet consectetur adipiscing elit ut aliquam purus.
                            Ac tincidunt vitae semper quis lectus nulla at volutpat. Enim lobortis scelerisque fermentum dui faucibus in ornare. In mollis nunc sed id semper. Vitae ultricies leo integer malesuada nunc vel risus commodo.
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import userService from "@/service/UserService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            await UserService.getUserPing();
        } catch (e) {
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            skipWelcome: true,
            userConfiguration: {},
            activeTab: 1
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            const [userConfigurationData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id),
            ]);

            this.userConfiguration = userConfigurationData.data;

            if (this.userConfiguration.showWelcome === 'Y') {
                this.skipWelcome = false;
            } else {
                this.skipWelcome = true;
            }
        },
        callUserManual() {
            this.safeNavigate('/usermanualIntroduction');
        },
        processConfiguration() {
            setTimeout(() => {
                this.$router.push("commonConfigurationBasic");
            }, 0);
        },
        processClient() {
            setTimeout(() => {
                this.$router.push("commonClients");
            }, 0);
        },
        processAppointment() {
            setTimeout(() => {
                this.$router.push("commonCalendar");
            }, 0);
        },
        processPayment() {
            setTimeout(() => {
                this.$router.push("commonFinancialInvoices");
            }, 0);
        },
        async onShowWelcomeChange() {

            try {
                if (this.skipWelcome === true) {
                    this.userConfiguration.showWelcome = 'N';
                } else {
                    this.userConfiguration.showWelcome = 'Y';
                }

                await userService.updateUserConfig(this.userStore.user.id, this.userConfiguration);

                try {
                    const [userConfigData] = await Promise.all([
                        UserService.getUserConfig(this.userStore.user.id)
                    ]);

                    this.userConfiguration = userConfigData.data;

                    if (this.userConfiguration.showWelcome === 'Y') {
                        this.skipWelcome = false;
                    } else {
                        this.skipWelcome = true;
                    }

                } catch (e) {
                    if (e.response && e.response.status === 401) {
                        this.$router.replace('/login');
                    } else {
                        this.userStore.clearUser();
                        this.$router.replace('/login');
                    }
                    return;
                }

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Configuration updated',
                    life: 3000
                });

            } catch (e) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update configuration. Please try again.',
                    life: 3000
                });
            }

        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
